import { Flex } from 'antd';

/** Toolbar aligned to the right of wave route tabs. */
export function WavesTabToolbar({ children }) {
  return (
    <Flex
      align="center"
      gap={8}
      justify="end"
      wrap="wrap"
      style={{ marginLeft: 'auto', maxWidth: '100%' }}
    >
      {children}
    </Flex>
  );
}
